import barba from '@barba/core';
import Swiper from 'swiper/bundle';
import { gsap } from "gsap";
var $ = require("jquery");
import 'jquery-ui';
window.jQuery = $;
require("@fancyapps/fancybox");
import * as validate from "jquery-validation"; // mi serve per mailerlite

function delay(n) {
  n = n || 2000;
  return new Promise(done => {
    setTimeout(() => {
      done();
    }, n);
  });
}

//  Animazione per tutte le pagine
function pageTransition() {
  var tl = gsap.timeline();
  tl.set('.loading-screen', { transformOrigin: "bottom left" });
  /* tl.to('.loading-screen', { duration: .5, scaleY: 1 });
  tl.to('.loading-screen', { duration: .5, scaleY: 0, skewX: 0, transformOrigin: "top left", ease: "power1.out", delay: 1 }); */

  tl.to('.loading-screen', { duration: .5, y: 0 });
  tl.to('.loading-screen', { duration: .5, y: -(window.innerHeight+100), transformOrigin: "top left", ease: 'Power1.easeInOut', delay: 1 });
}


function mos() {
  var tl = gsap.timeline();
  tl.set('.loading-screen', { transformOrigin: "top right" });
  tl.to('.loading-screen', { duration: .5, scaleY: 1 });
  tl.to('.loading-screen', { duration: .5, scaleY: 0, skewX: 0, transformOrigin: "top left", ease: "power1.out", delay: 1 });
}



//barba.use(barbaCss);
barba.init({ 
  debug: true,
  sync: true,
  //preventRunning: true,
  timeout: 30000,
  prevent: ({ el }) => el.classList && el.classList.contains('no-barba'),

  transitions: [{
    name: 'fade',
    async leave(data) {
      const done = this.async();
      pageTransition();
      await delay(1000);
      done();
    },

    async enter(data) {
    },

    async once(data) {
    }
  },
  ]
});

barba.hooks.after(() => {
//  console.log('after');

ga('set', 'page', window.location.pathname);
  ga('send', 'pageview');
});

// Setto le <body> classes, barba.hooks.afterLeave rimpiazza il vecchio Barba.Dispatcher.on("newPageReady"...
barba.hooks.afterLeave((data) => {
  var nextHtml = data.next.html;
  var response = nextHtml.replace(/(<\/?)body( .+?)?>/gi, '$1notbody$2>', nextHtml)
  var bodyClasses = $(response).filter('notbody').attr('class')
  $("body").attr("class", bodyClasses);

});

barba.hooks.beforeEnter(() => {
  window.scrollTo(0,0);
});

// Carico gli script di terze parti
barba.hooks.afterEnter(() => {



        var swiper1 = new Swiper('.swiper1', {

          //speed: 1,
          autoplay: {
            delay: 9000,
            disableOnInteraction: false
          },
          effect: 'fade',
          fadeEffect: {
            crossFade: true
          },
          pagination: {
            el: '.swiper-pagination1',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        });

        var swiper2 = new Swiper('.swiper2', {
          slidesPerView: 3,
          speed: 600,
          spaceBetween: 30,
          loop: false,
          /*autoplay: {
            delay: 3000,
            disableOnInteraction: false
          },*/
          breakpoints: {
            1024: {
              slidesPerView: 3,
              spaceBetween: 10
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 30
            },
            640: {
              slidesPerView: 1,
              spaceBetween: 20
            },
            320: {
              slidesPerView: 1,
              spaceBetween: 10
            }
          },
          // init: false,
          pagination: {
            el: '.swiper-pagination2',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next2',
            prevEl: '.swiper-button-prev2'
          }
        });

        var swiper3 = new Swiper('.swiper3', {
          slidesPerView: 3,
          spaceBetween: 90,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false
          },
          // init: false,
          pagination: {
            el: '.swiper-pagination3',
            clickable: true
          },
          breakpoints: {
            1024: {
              slidesPerView: 3,
              spaceBetween: 90
            },
            0: {
              slidesPerView: 1,
              spaceBetween: 20
            }
          }
        });

        var swiper4 = new Swiper('.swiper4', {
          slidesPerView: 8,
          spaceBetween: 10,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false
          },
          // init: false,
          pagination: {
            el: '.swiper-pagination4',
            clickable: true
          },
          breakpoints: {
            1024: {
              slidesPerView: 8,
              spaceBetween: 10
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 30
            },
            0: {
              slidesPerView: 2,
              spaceBetween: 15
            }
          },
          navigation: {
            nextEl: '.swiper-button-next4',
            prevEl: '.swiper-button-prev4'
          }
        });



    $( document ).ready(function() {

              var getHeader = $('.wrap-header');
              var spaceHeader = $('.space-header');
              if (getHeader && spaceHeader) {
                spaceHeader.css('height', getHeader.innerHeight());
              } 

              var luoghiUnique = luoghi.filter(function(item, pos){
                return luoghi.indexOf(item)== pos; 
              });

              jQuery( "#project-luoghi" ).autocomplete({
                source: luoghiUnique,
                focus: function( event, ui ) {
                    jQuery( "#project-luoghi" ).val( ui.item.value );
                    return false;
                },
                select: function( event, ui ) {
                    jQuery( "#project-luoghi" ).val( ui.item.value );
                    return false;
                }
              });

              //backToTheTop
              var offset = 300,
                offset_opacity = 1200,
                scroll_top_duration = 700;
              var $back_to_top = $('.qpc-top');
              $(window).scroll(function() {
                ($(this).scrollTop() > offset) ? $back_to_top.addClass('qpc-is-visible') : $back_to_top.removeClass('qpc-is-visible');
                if ($(this).scrollTop() > offset_opacity) {
                  $back_to_top.addClass('qpc-fade-out');
                }
              });

              //smooth scroll to top
              $back_to_top.on('click', function(event) {
                event.preventDefault();
                $('body,html').animate({
                  scrollTop: 0
                }, scroll_top_duration
                );
              });

              //autocomplete selection
              $('#ui-id-1').on('click',function(){
                $('.default-content').hide();
                fetch();
              });

              //chef filters

              let click_first_char; 

              jQuery('#a-z li.active').click(function() 
              {
                jQuery('#posts-results div').removeClass('show');
                jQuery('#posts-results div.chef').addClass('hide');
                jQuery('#a-z li.active').removeClass('current'); 
                click_first_char = jQuery(this).data('letter'); 
                jQuery(this).addClass('current');
                jQuery("#posts-results [data-letter="+click_first_char+"]").removeClass('hide').addClass('show');
              });

                let initial_first_letter = jQuery('#a-z div.active:eq(0)').data('letter'); 
                let posts_results_li = jQuery("#posts-results div"); 
                
                jQuery("#posts-results [data-letter="+ initial_first_letter +"]").addClass('show'); 
                jQuery('#a-z li.active:eq(0)').addClass('current'); 



                jQuery('.mailerlite-subscribe-button-container').append('<div class="clear"></div><input type="checkbox" name="mailerlite_privacy" id="mailerlite_privacy" required>  <a href="https://www.iubenda.com/privacy-policy/7820486" target="_blank">Autorizzo ai sensi dell’art. 13 D.lgs. 13/06, informato ai sensi dell’art. 7 D.lgs. 13/06”</a>');
                jQuery('.mailerlite-subscribe-button-container').append('<div class="clear"></div><input type="checkbox" name="mailerlite_gdpr" id="mailerlite_gdpr" required>  <a href="https://www.iubenda.com/privacy-policy/7820486" target="_blank">Autorizzo il Salvataggio e la Manipolazione dei miei Dati Personali (GDPR)</a>');

    });

                      // end chef filters

                      jQuery(document).ready(function () {
                        $(".gallery-icon a, .wpml-ls-link, .ab-item, #wp-toolbar a, #wpadminbar a, .extra-menu a, #wp-toolbar a").addClass("no-barba");
                      });

                      jQuery('.gallery-item').each(function() {
                        jQuery(this).find(".gallery-icon a").attr('data-fancybox', 'group-Gallery' + $(this).parent().attr('id'));
                        var caption = $(this).find('.wp-caption-text').text();
                        //alert(caption);
                        jQuery(this).find('.immagine-gallery').attr('title', caption);
                      });

                      jQuery("a.gallery-chef-link").fancybox(); 


                      $(".left-layer").addClass("active");

                      $(".toggle").on('click', function(event) {
                        $(".popout").toggle({ direction: "left" }, 300, function() {
                        });
                        //  event.stopImmediatePropagation(); // lo utilizzo per barba altrimenti il toggle viene richiamato 2 volte
                      });



                      // Prendo l'elemento tab__content più alto
                      let height = -1;
                      $('.tab__content').each(function() {
                        height = height > $(this).outerHeight() ? height : $(this).outerHeight();
                        $(this).css('position', 'absolute');
                      });
                      // Setto l'altezza del tab prendendo l'elemento più alto di tab__content
                      $('[data-tabs]').css('height', height + 100 + 'px');

                      /*
                          var tl = new TimelineLite,
                          mySplitText = new SplitText(".quote", {type:"words,chars"}),
                          chars = mySplitText.chars; //an array of all the divs that wrap each character

                          TweenLite.set(".quote", {perspective:400});

                          tl.staggerFrom(chars, 0.8, {opacity:0, scale:0, y:80, rotationX:180, transformOrigin:"0% 50% -50",  ease:Back.easeOut}, 0.01, "+=0");
                      */


                      // SCROLLING ANCORE
                      /* va in conflitto con le frecce del bootstrap-carousel e i tab jquery, mettere un selettore.*/
                      $('a[href*=\\#]:not([href=\\#])').click(function() {
                        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
                          | location.hostname == this.hostname) {
                          var target = $(this.hash);
                          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                          if (target.length) {
                            $('html,body').animate({
                              scrollTop: target.offset().top
                            }, 1000);
                            return false;
                          }
                        }
                      });

                      $('#menu-main a[href*=\\#]').click(function(e) {
                        e.preventDefault();
                      });



                      $(window).scroll(function() {
                        if(window.innerWidth < 768) return;
                        var scroll = $(window).scrollTop();

                        if (scroll >= 500) {
                          $(".wrap-header, #page-logo").addClass("sticky");
                          $("#menu-mos, #menu-menu-en").addClass("menu-qpc-class sticky");

                        } else {
                          $(".wrap-header, #page-logo,  #menu-mos, #menu-menu-en").removeClass("sticky");
                          $("#menu-mos, #menu-menu-en").addClass("menu-qpc-class");

                        }
                      });

                      // su mobile risolvo il click della tendina nel caso ci fosse assegnato un url
                      $(".nav-menu ul li a").on('touchstart', function(e) {
                        'use strict';
                        var link = $(this);
                        if (link.hasClass('hover')) {
                          return true;
                        } else {
                          link.addClass('hover');
                          $('.nav-menu ul li a').not(this).removeClass('hover');
                          e.preventDefault();
                          return false;
                        }
                      });


});


// Evito il ricaricamento di Barba nella pagina corrente
var links = document.querySelectorAll('a[href]');
var cbk = function(e) {
  if (e.currentTarget.href === window.location.href) {
    e.preventDefault();
    e.stopPropagation();
  }
};
for (var i = 0; i < links.length; i++) {
  links[i].addEventListener('click', cbk);
}

// Autocomplete jquery-ui

